const topicItems = [
  { label: '娱乐圈大瓜', hot: true, count: '3.2万讨论' },
  { label: '网红翻车现场', hot: true, count: '2.8万讨论' },
  { label: '明星恋情实锤', hot: true, count: '5.1万讨论' },
  { label: '综艺内幕爆料', hot: false, count: '1.6万讨论' },
  { label: '影视幕后花边', hot: false, count: '9.8千讨论' },
  { label: '直播圈大事件', hot: true, count: '2.3万讨论' },
  { label: '体育明星八卦', hot: false, count: '7.5千讨论' },
  { label: '社会热点追踪', hot: true, count: '6.7万讨论' },
  { label: '国际娱乐速递', hot: false, count: '8.2千讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            当前最受关注的吃瓜话题标签，点击探索你感兴趣的瓜田
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, idx) => (
            <a
              key={idx}
              href="#topics"
              className="group relative inline-flex flex-col items-center gap-1.5 px-5 py-3.5 rounded-2xl border transition-all cursor-pointer bg-background-50 border-background-200/70 hover:border-primary-300 hover:bg-primary-50/40"
            >
              <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.hot && (
                  <span className="inline-flex items-center mr-1.5">
                    <i className="ri-fire-fill text-accent-500 text-xs"></i>
                  </span>
                )}
                #{item.label}
              </span>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}